import React, { Fragment, useState } from "react";
import { useFormikContext } from "formik";
import PricesCurrencySelect from "components/PricesCurrencySelect";
import { getCurrencyConfigForLocale } from "components/FormerEditor/common/currency";
import { getPrimaryForProductIntervalCurrency } from "utils/pricing";
import IntervalPrices from "./IntervalPrices";
import { STATE_KEYS } from "utils/constants/state";
import groupBy from "lodash/groupBy";
import get from "lodash/get";

const ProductPricePrimaryPicker = ({ id, prices }) => {
  const { values } = useFormikContext();
  const { primaries } = values;

  // Put path into state
  const INTERVAL_SET = get(values, "form.prices.intervals");

  const currencyConfig = getCurrencyConfigForLocale();
  const initialCurrency = currencyConfig.code.toLowerCase();
  const [activeCurrency, setActiveCurrency] = useState(initialCurrency);
  const filteredPrices = prices.filter(
    (price) => price.currency === activeCurrency
  );
  const priceGroups = groupBy(filteredPrices, STATE_KEYS.PRICE.INTERVAL);

  return (
    <Fragment>
      <PricesCurrencySelect
        prices={prices}
        value={activeCurrency}
        setActiveCurrency={setActiveCurrency}
      />
      {INTERVAL_SET.map((interval, intervalIx) => (
        <IntervalPrices
          key={intervalIx}
          isFirst={!intervalIx}
          isLast={INTERVAL_SET.length - 1 === intervalIx}
          interval={interval}
          primary={getPrimaryForProductIntervalCurrency({
            primaries,
            interval,
            currency: activeCurrency,
            product: id
          })}
          prices={priceGroups[interval]}
        />
      ))}
    </Fragment>
  );
};

export default ProductPricePrimaryPicker;
